import Vue from 'vue';
import * as debounce from 'debounce';
import * as MobileDetect from 'mobile-detect';
import toggleClass from './utils/toggleClass';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export const UtilsBus = new Vue({
  data() {
    const htmlEl = window.document.documentElement;
    const bodyEl = window.document.body;
    const navPopupEl = document.querySelector('#nav-popup');

    return {
      bodyEl,
      htmlEl,
      navPopupEl,
      stageWidth: window.innerWidth,
      stageHeight: window.innerHeight,
      isMobile: false,
      isHome: false,
      eventHub: null,
      htmlClasses: htmlEl.className.split(' ').map(c => c.trim()).filter(c => c),
      bodyClasses: bodyEl.className.split(' ').map(c => c.trim()).filter(c => c),
    };
  },

  created() {
    window.addEventListener('resize', debounce(this.onResize.bind(this), 200));
    const mobileDetect = new MobileDetect(window.navigator.userAgent);
    this.isMobile = !!mobileDetect.mobile();
    this.isTablet = !!mobileDetect.tablet();
    if (this.isMobile) { this.bodyEl.classList.add('mobile'); }
    if (this.isTablet) { this.bodyEl.classList.add('tablet'); }
    if (this.bodyEl.classList.contains('home')) {
      this.isHome = true;
    }

    this.addEventListeners();
  },

  watch: {
    htmlClasses: {
      immediate: true,
      handler(value, oldValue) {
        if (oldValue && oldValue.length) {
          oldValue.forEach(v => this.htmlEl.classList.remove(v));
        }
        value.forEach(v => this.htmlEl.classList.add(v));
      },
    },
  },

  methods: {
    onResize() {
      this.stageWidth = window.innerWidth;
      this.stageHeight = window.innerHeight;
      this.$emit('stageResize', { width: this.stageWidth, height: this.stageHeight });
    },
    onPageReady() {
      this.toggleHtmlClass({
        className: 'is-page-ready',
        force: true,
      });
    },
    addEventListeners() {
      this.$on('nav:color', (color) => {
        this.toggleHtmlClass({
          className: `is-nav-${color}`,
          removePattern: /is-nav-/,
          force: true,
        });
      });
      this.$on('logo:color', (color) => {
        this.toggleHtmlClass({
          className: `is-logo-${color}`,
          removePattern: /is-logo-/,
          force: true,
        });
      });
      this.$on('logo:show', (show) => {
        this.toggleHtmlClass({
          className: 'is-logo-hidden',
          force: !show,
        });
      });
      this.$on('nav:show', (show) => {
        this.toggleHtmlClass({
          className: 'is-nav-hidden',
          force: !show,
        });
      });

      this.$on('nav-popup:show', this.toggleNavPopup);
    },

    toggleHtmlClass({ className, removePattern = null, force = null }) {
      this.htmlClasses = toggleClass({
        classesList: this.htmlClasses,
        className,
        removePattern,
        force,
      });
    },

    isNavPopupVisible() {
      return this.htmlClasses.indexOf('is-navpopup-visible') > -1;
    },

    toggleNavPopup(show = null) {
      const isVisible = this.isNavPopupVisible();
      const display = show === null ? !isVisible : show;
      this.toggleHtmlClass({
        className: 'is-navpopup-visible',
        force: display,
      });

      if (display) {
        disableBodyScroll(this.navPopupEl)
      } else {
        enableBodyScroll(this.navPopupEl);
      }
    }
  },
});
